export const formatStringToLocale = (string: string) => {
  const isNumber = !isNaN(parseInt(string, 10))
  if (isNumber) {
    const removeCommas = string.replace(/,/g, '') || '0'
    return formatNumberToLocale(parseInt(removeCommas, 10))
  }

  return ''
}

export const formatNumberToLocale = (number: number) => number.toLocaleString('en-GB')

export const numbersFromString = (string: string) => string.replace(/\D/g, '')
